import { DataBean } from "../DataBean";

export class Project extends DataBean {


    public async getProjectCatalogPorPropiedades(properties: any, maxRows: any): Promise<any> {
        return this.getCustomService("FinanceCore", "java.util.List_getProjectCatalogPorPropiedades_java.util.Map_Number", [properties, maxRows]);
    }

    public async getProjectModificationReport(idEmployee: number, idProject: number): Promise<any> {
        return this.getCustomService("FinanceCore", "com.advantage.shared.Report_getProjectModificationReport_Number_Number", [idEmployee, idProject]);
    }

    public async getProjectCatalogPorPropiedadesRender(props: any, rows: any): Promise<any> {
        return this.getCustomService("FinanceCore", "java.util.List_getProjectCatalogPorPropiedadesRender_java.util.Map_Number", [props, rows]);
    }
    public async getProjectRender1(page: number, rows: any, props: any): Promise<any> {
        return this.getCustomService("FinanceCore", "java.util.List_getProjectRender_Number_Number_java.util.Map",
            [page, rows, props]
        );
    }
    public async getProjectRender(page: number, rows: any, props: any): Promise<any> {
        return this.getCustomService("FinanceCore", "com.advantage.shared.Report_getProjectRender_Number_Number_java.util.Map",
            [page, rows, props]
        );
    }



}